import _ from 'lodash'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

import { themeColor, themeFontSize, themeSpace } from '../theme'

const LevelIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${themeSpace(3)};
`

const Title = styled.span`
  font-size: ${themeFontSize('medium')};
  font-weight: bold;
  margin-right: ${themeSpace(3)};
`

const Indicators = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-grow: 1;
`

const Indicator = styled.div<{ active: boolean }>`
  flex: 1;
  height: 8px;
  border-radius: 4px;
  background: ${({ active }) => (active ? themeColor('success') : themeColor('gray'))};
  margin-left: 4px;
`

interface LevelIndicatorProps {
  title: string
  level: number
  maxLevel: number
}

export const LevelIndicator: FunctionComponent<LevelIndicatorProps> = ({ title, maxLevel, level }) => {
  return (
    <LevelIndicatorContainer>
      <Title>{title}</Title>
      <Indicators>
        {_.times(maxLevel, l => (
          <Indicator key={l} active={level > l} />
        ))}
      </Indicators>
    </LevelIndicatorContainer>
  )
}
